// import external dependencies
import 'jquery';

import { library, dom, config } from '@fortawesome/fontawesome-svg-core'
config.searchPseudoElements = true;
//import { fas } from '@fortawesome/free-solid-svg-icons'
//import { far } from '@fortawesome/free-regular-svg-icons';
//import { fab } from '@fortawesome/free-brands-svg-icons';
//import { fas } from '@fortawesome/pro-solid-svg-icons';
//import { far } from '@fortawesome/pro-regular-svg-icons';
//import { fal } from '@fortawesome/pro-light-svg-icons';
import {  faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons';
import {  faSearch, faCircle, faEnvelope, faTimes, faBars, faCaretLeft, faCaretRight, faCaretUp, faCaretDown, faArrowRight } from '@fortawesome/pro-solid-svg-icons';
//library.add(faCaretLeft,faCaretRight,faArrowRight);
library.add( faSearch, faCircle, faLinkedinIn, faTwitter, faEnvelope, faTimes, faBars, faCaretLeft, faCaretRight, faArrowRight, faCaretUp, faCaretDown );
dom.watch()

import AOS from 'aos';

// Import everything from autoload
import './autoload/_bootstrap.js';
import 'slick-carousel/slick/slick.min';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import archiveProfessionistiData from './routes/archiveProfessionisti';
import singleAreaDiAttivitaData from './routes/singleAreaDiAttivita';
import newsletter from './routes/newsletter';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  archiveProfessionistiData,
  singleAreaDiAttivitaData,
  newsletter,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
AOS.init({
  once: true,
});


// WEBPACK FOOTER //
// ./scripts/main.js